export default __webpack_public_path__ + "static/js-73aae693909126986e3e6a1fe9edfe28.png";